var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"is-full-page":_vm.fullPage,"color":_vm.color,"loader":_vm.loader,"background-color":_vm.bgColor,"height":_vm.height,"width":_vm.width},on:{"update:active":function($event){_vm.isLoading=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }